import { render, staticRenderFns } from "./addEmail.vue?vue&type=template&id=22ba927c"
import script from "./addEmail.vue?vue&type=script&lang=js"
export * from "./addEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports